export const GeoOptions = [
  {
    label: "United States",
    value: "United States",
  },
  {
    label: "Europe",
    value: "Europe",
  },
  {
    label: "Asia",
    value: "Asia",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const AreaOfExpertiseOptions = [
  {
    label: "Engineering",
    value: "Engineering",
  },
  {
    label: "Medicine",
    value: "Medicine",
  },
  {
    label: "Law",
    value: "Law",
  },
  {
    label: "Finance",
    value: "Finance",
  },
  {
    label: "Entrepreneur",
    value: "Entrepreneur",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const YearsOfExperienceOptions = [
  {
    label: "1-5 years",
    value: "1-5 years",
  },
  {
    label: "5-10 years",
    value: "5-10 years",
  },
  {
    label: "Above 10 years",
    value: "Above 10 years",
  },
];

export const CostingOptions = [
  {
    label: "Free",
    value: "Free",
  },
  {
    label: "20$",
    value: 20,
  },
  {
    label: "50$",
    value: 50,
  },
  {
    label: "Other",
    value: "Other",
  },
];
